import { render, staticRenderFns } from "./VirtualTree.vue?vue&type=template&id=0a89f4ae&scoped=true"
import script from "./VirtualTree.vue?vue&type=script&lang=js"
export * from "./VirtualTree.vue?vue&type=script&lang=js"
import style0 from "./VirtualTree.vue?vue&type=style&index=0&id=0a89f4ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a89f4ae",
  null
  
)

export default component.exports